import type { Direction } from "../../../engine/direction";
import type { RGBColor } from "../interpolation";
import { BurstParticle } from "./burstParticle";

export class MuzzleFlashParticle extends BurstParticle {
	constructor(originX: number, originY: number, direction?: Direction, opts?: {
		color?: RGBColor;
		speed?: [number, number];
		coneHalfAngle?: number;
		ttl?: [number, number];
		size?: [number, number];
		opacityHold?: number;
	}) {
		super(
			originX,
			originY,
			{
				ttl: opts?.ttl ?? [100, 200],
				size: opts?.size ?? [0.4, 0.25],
				color: opts?.color ?? { r: 255, g: 180, b: 50 },
				speed: opts?.speed ?? [9.5, 12.0],
				gravity: 1.0,
				coneHalfAngle: opts?.coneHalfAngle ?? Math.PI / 12,
				opacityHold: opts?.opacityHold,
			},
			direction,
		);
	}
}
